import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LayoutComponent } from "./layout/layout.component";
import { PlatformService } from "./core/services/platform.service";
import { TenantContextService } from "./core/services/tenant-context.service";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [CommonModule, LayoutComponent],
  templateUrl: "./app.component.html",
  styles: [],
})
export class AppComponent {
  constructor(
    private _plateForm: PlatformService,
    private _tenantContext: TenantContextService
  ) {
    this._plateForm.setLanguage();
    const hasToken = localStorage.getItem("Token") || sessionStorage.getItem("Token");
    if (hasToken) {
      this._tenantContext.load();
    }
  }
}
